/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media screen and (max-width:599px){.request-form-dialog{width:100%}}@media screen and (min-width:600px){.request-form-dialog{width:400px}}.request-form-dialog .mat-dialog-container{padding:0}.request-form-dialog .mat-dialog-container .mat-toolbar{-webkit-box-flex:1;flex:1 0 auto;min-height:initial}.request-form-dialog .mat-dialog-container .toolbar-bottom{height:auto}.request-form-dialog .dialog-content-wrapper{max-height:85vh;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column}"];
export { styles as styles };
